<template>
    <table>
        <tr>
            <th class="title-header">{{pool.name}}</th>
            <th class="result-header">результат</th>
        </tr>
        <tr class="title-row">
            <td class="title"><h1>{{pool.title}}</h1></td>
            <td :class="isValid(pool.result)" class="result"><h2>{{resultView(pool.result)}}</h2></td>
        </tr>
    </table>

</template>

<script>
    export default {
        name: "QuestionsHeader",
        props: ['pool'],
        methods: {
            resultView(value) {
                if (value === 0) {
                    return null
                }
                return value;
            },
            isValid(value) {
                console.log('isValid: ', value);
                let is_risk = false;
                let is_valid = false;
                if (value < this.$store.getters.Q_ONE.min_level) {
                    is_risk = true;
                }
                if (value === 0) {
                    is_risk = false;
                }
                if (value === null) {
                    is_risk = false;
                }
                if (value >= this.$store.getters.Q_ONE.min_level) {
                    is_valid = true;
                }
                if (value === '2НД') {
                    is_valid = false;
                    is_risk = true;
                }
                return {
                    risk: is_risk,
                    valid: is_valid
                }
            }
        }
    }
</script>

<style scoped>
    table {
        border: none;
        border-collapse: collapse;
        width: 100%;
    }

    td {
        border: 1px solid black;
        border-collapse: collapse;
    }

    th, td {
        padding: 0px;
        text-align: center;
    }

    .title-header {
        text-align: left;
    }

    .title-row {
        background-color: #fadab2;
    }

    .result-header, .result {
        width: 20%;
    }

    .risk {
        background-color: red;
    }
    .valid {
        background-color: green;
    }

</style>